import { useCallback, useEffect, useState } from "react";
import DataTable from "../datatable/DataTable";
import { Link } from "react-router-dom";
import "./tags.css";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";

const tagListEndpoint = ApiEndpoints.tags.tagList;
const tagDeleteEndpoint = ApiEndpoints.tags.tagDelete;
const tagEditPath = "edit-tags";
const tableHeader = ["Name"];
const tbody = ["name"];

export default function Tags() {

  const [data, setData] = useState([]);

  const dataFetch = useCallback(async () => {
    try {
      const response = await ApiRequest("GET", tagListEndpoint);
      const result = response.tags;
      setData(result);
    } catch (error) {
      console.error("Error fetching tags:", error);
    }
  }, []);

  useEffect(() => {
    dataFetch();
  }, [dataFetch]);

  const handleDelete = useCallback(
    async (tag_id) => {
      const payload = { tag_id };
      try {
        await ApiRequest("POST", tagDeleteEndpoint, payload);
        await dataFetch();
      } catch (error) {
        console.error("Error deleting tag:", error);
        alert("Failed to delete the tag.");
      }
    },
    [dataFetch] 
  );

  return (
    <>
      <div className="header-add-category">
        <h5>Tags</h5>
      </div>

      <div className="add-tags-section">
        <Link className="default-btn" to="/admin/add-tags">
          add Tag
        </Link>
        <DataTable
          data={data}
          tableHeader={tableHeader}
          tbody={tbody}
          editPath={tagEditPath}
          onDelete={handleDelete}
        />
      </div>
    </>
  );
}
